var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { MenuItem as MuiMenuItem } from '@mui/material';
import Calendar from '../../assets/icons/Calendar';
import Select from '../SelectInput';
import Text from '../Text';
import colors from '../../themes/colors';
import { getSelectedTimeFrame } from './formatSelectedDateRange';
var StyledMuiItem = styled(MuiMenuItem)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &:hover {\n    background-color: inherit;\n  }\n"], ["\n  &:hover {\n    background-color: inherit;\n  }\n"])));
var StyledSelect = styled(Select)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: ", ";\n\n  > fieldset {\n    border-radius: 4px;\n    border: 2px solid ", " !important;\n  }\n\n  ", "\n"], ["\n  background-color: ", ";\n\n  > fieldset {\n    border-radius: 4px;\n    border: 2px solid ", " !important;\n  }\n\n  ", "\n"])), function (_a) {
    var isOpen = _a.isOpen;
    return (isOpen ? colors.neutral10 : 'transparent');
}, colors.neutral20, function (_a) {
    var disabled = _a.disabled;
    if (!disabled)
        return '';
    return "\n      background-color: ".concat(colors.neutral0, ";\n      border-color: ").concat(colors.neutral10, ";\n\n      > :is(svg, path) {\n        fill: ").concat(colors.neutral40, ";\n      }\n    ");
});
var Flex = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  gap: 4px;\n  justify-content: center;\n  align-items: center;\n\n  ", "\n"], ["\n  display: flex;\n  gap: 4px;\n  justify-content: center;\n  align-items: center;\n\n  ", "\n"])), function (_a) {
    var disabled = _a.disabled;
    if (!disabled)
        return '';
    return "\n      & > :not(:where(svg)) {\n        color: ".concat(colors.neutral30, ";\n      }\n\n      & :is(svg, path) {\n        fill: ").concat(colors.neutral40, ";\n      }\n    ");
});
var DatePickerSelectWithoutDateRange = function (props) {
    var children = props.children, dateRange = props.dateRange, disabled = props.disabled, isOpen = props.isOpen, onOpen = props.onOpen;
    var selectedTimeFrame = getSelectedTimeFrame(dateRange);
    return (_jsx(StyledSelect, __assign({ value: "picker", noPadding: true, isOpen: isOpen, disabled: disabled, onSelectClick: onOpen, forceOpen: isOpen, renderValue: function () { return (_jsxs(Flex, __assign({ disabled: disabled }, { children: [_jsx(Calendar, {}), _jsx(Text, __assign({ variant: "body2Semibold" }, { children: selectedTimeFrame }))] }))); } }, { children: _jsx(StyledMuiItem, __assign({ style: {
                padding: '0px',
                backgroundColor: 'transparent',
                cursor: isOpen ? 'default' : 'cursor'
            }, disableRipple: true, disableGutters: true, tabIndex: -1, selected: false, value: "picker", onClick: function (e) {
                e.preventDefault();
                e.stopPropagation();
            } }, { children: children })) })));
};
export default DatePickerSelectWithoutDateRange;
var templateObject_1, templateObject_2, templateObject_3;
